export default __webpack_public_path__ + "static/schedule-calendar-m-b8d538e6eba7a698ab33dadfe205bc53.webp";